import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Banner.css';
import { bannerConfig, shouldShowBannerOnPage } from '../config/bannerConfig';

const Banner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if banner should show on current page
    const shouldShow = shouldShowBannerOnPage(location.pathname);
    
    // Check if banner is enabled and not dismissed
    if (shouldShow && bannerConfig.enabled && bannerConfig.showOnDesktop) {
      // Check localStorage to see if user dismissed this banner
      const dismissedKey = `banner_dismissed_${bannerConfig.content.type}`;
      const wasDismissed = localStorage.getItem(dismissedKey) === 'true';
      
      if (!wasDismissed) {
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  const handleDismiss = () => {
    if (bannerConfig.content.dismissible) {
      setIsDismissed(true);
      setIsVisible(false);
      // Save dismissal to localStorage
      const dismissedKey = `banner_dismissed_${bannerConfig.content.type}`;
      localStorage.setItem(dismissedKey, 'true');
    }
  };

  if (!isVisible || isDismissed || !bannerConfig.enabled || !bannerConfig.showOnDesktop) {
    return null;
  }

  const content = bannerConfig.content;
  const sizeClass = content.size || 'normal';
  const position = bannerConfig.position;
  
  // Add side positioning class if position is side-left or side-right
  const positionClass = (position === 'side-left' || position === 'side-right') 
    ? `banner--${position}` 
    : '';
  
  const BannerContent = (
    <div 
      className={`banner banner--${sizeClass} ${positionClass}`}
      style={{
        background: content.backgroundColor || undefined,
        color: content.textColor || undefined,
      }}
    >
      <div className="banner__content">
        {content.icon && (
          <span className="banner__icon">{content.icon}</span>
        )}
        <div className="banner__text">
          <h3 className="banner__title">{content.title}</h3>
          {content.description && (
            <p className="banner__description">{content.description}</p>
          )}
        </div>
        {content.link && (
          <div className="banner__action">
            {content.link.startsWith('http') ? (
              <a 
                href={content.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="banner__link"
              >
                {content.linkText || 'Узнать больше'}
              </a>
            ) : (
              <Link to={content.link} className="banner__link">
                {content.linkText || 'Узнать больше'}
              </Link>
            )}
          </div>
        )}
      </div>
      {content.dismissible && (
        <button 
          className="banner__close"
          onClick={handleDismiss}
          aria-label="Закрыть"
        >
          ×
        </button>
      )}
    </div>
  );

  return BannerContent;
};

export default Banner;
